import React from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { Paper, BottomNavigation, BottomNavigationAction } from '@mui/material';
import { Dashboard, People, ShoppingCart, LocalShipping, Task, Badge, TwoWheeler, AssignmentReturn, EventAvailable, EventRepeat, Menu as MenuIcon } from '@mui/icons-material';
import { useAuth, isAdminLevel } from '../AuthContext';

const getPrimaryNavItems = (roleSlug) => {
  const isAdminLevelUser = isAdminLevel(roleSlug);

  if (roleSlug === 'hr') {
    return [
      { to: '/candidates', icon: <Badge />, label: 'المتقدمين' },
      { to: '/followups', icon: <EventRepeat />, label: 'متابعات' },
    ];
  }
  if (['developer', 'marketing'].includes(roleSlug)) {
    return [{ to: '/tasks', icon: <Task />, label: 'Tasks' }];
  }
  if (roleSlug === 'warehouse') {
    return [
      { to: '/deals', icon: <LocalShipping />, label: 'تجهيز' },
      { to: '/returns', icon: <AssignmentReturn />, label: 'مرتجعات' },
      { to: '/tasks', icon: <Task />, label: 'Tasks' },
    ];
  }
  if (roleSlug === 'delivery_rep') {
    return [
      { to: '/delivery', icon: <TwoWheeler />, label: 'أوردراتي' },
      { to: '/tasks', icon: <Task />, label: 'Tasks' },
    ];
  }
  if (roleSlug === 'outside_sales') {
    return [
      { to: '/visits', icon: <EventAvailable />, label: 'زيارات' },
      { to: '/followups', icon: <EventRepeat />, label: 'متابعات' },
      { to: '/delivery', icon: <TwoWheeler />, label: 'أوردراتي' },
      { to: '/clients', icon: <People />, label: 'العملاء' },
    ];
  }
  if (roleSlug === 'sales_rep') {
    return [
      { to: '/clients', icon: <People />, label: 'العملاء' },
      { to: '/followups', icon: <EventRepeat />, label: 'متابعات' },
      { to: '/orders', icon: <ShoppingCart />, label: 'أوردرات' },
      { to: '/tasks', icon: <Task />, label: 'Tasks' },
    ];
  }
  if (roleSlug === 'customer_service') {
    return [
      { to: '/clients', icon: <People />, label: 'العملاء' },
      { to: '/orders', icon: <ShoppingCart />, label: 'أوردرات' },
      { to: '/tasks', icon: <Task />, label: 'Tasks' },
    ];
  }
  if (isAdminLevelUser || roleSlug === 'sales_manager') {
    return [
      { to: '/dashboard', icon: <Dashboard />, label: 'الرئيسية' },
      { to: '/clients', icon: <People />, label: 'العملاء' },
      { to: '/orders', icon: <ShoppingCart />, label: 'أوردرات' },
      { to: '/tasks', icon: <Task />, label: 'Tasks' },
    ];
  }
  return [{ to: '/tasks', icon: <Task />, label: 'Tasks' }];
};

const BottomNav = ({ onMoreClick }) => {
  const { currentUser } = useAuth();
  const { pathname } = useLocation();
  const navigate = useNavigate();

  if (!currentUser) return null;

  const items = getPrimaryNavItems(currentUser.roleSlug);
  const isActive = (to) => pathname === to || pathname.startsWith(`${to}/`);
  const activeIndex = items.findIndex((item) => isActive(item.to));
  const value = activeIndex === -1 ? items.length : activeIndex;

  return (
    <Paper
      elevation={8}
      sx={{
        display: { xs: 'block', md: 'none' },
        position: 'fixed',
        bottom: 0,
        left: 0,
        right: 0,
        zIndex: 1250,
      }}
    >
      <BottomNavigation
        showLabels
        value={value}
        onChange={(e, newValue) => {
          if (newValue === items.length) {
            onMoreClick();
          } else {
            navigate(items[newValue].to);
          }
        }}
      >
        {items.map((item) => (
          <BottomNavigationAction key={item.to} label={item.label} icon={item.icon} />
        ))}
        <BottomNavigationAction label="المزيد" icon={<MenuIcon />} />
      </BottomNavigation>
    </Paper>
  );
};

export default BottomNav;
